import * as React from "react";
import {
  Box,
  Typography,
  Stack,
  Paper,
  Button,
} from "@mui/material";
import { useI18n } from "../../i18n/I18nProvider";


export default function AvailabilityAwareness(props: {handlePageChange: (p: string) => void}) {
  const { lang } = useI18n();
  const isDE = lang === "de";

  return (
    <Box
      sx={{
        minHeight: "100vh",
        px: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: `
          radial-gradient(circle at 20% 20%, rgba(251, 2, 2, 0.08), transparent 40%),
          radial-gradient(circle at 80% 30%, rgba(255, 0, 0, 0.06), transparent 40%),
          #111010
        `,
        backgroundImage: `
          linear-gradient(
            rgba(8, 8, 8, 0.78),
            rgba(8, 8, 8, 0.82)
          ),
          url("/scenarioBgs/availability.png")
        `,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: { xs: "scroll", md: "fixed" },
        py: { xs: 3, sm: 5 },
      }}
    >
      <Paper
        sx={{
          width: "min(900px, 100%)",
          maxWidth: 900,
          p: { xs: 2.5, sm: 4, md: 5 },
          borderRadius: { xs: 3, sm: 5 },
          background: "linear-gradient(180deg, #311f1f, #221515)",
        }}
      >
        <Stack spacing={{ xs: 3, sm: 4 }}>

          {/* TITLE */}
          <Typography
            sx={{
              color: "#fff",
              fontWeight: 800,
              fontSize: { xs: "1.3rem", sm: "1.5rem", md: "1.6rem" },
            }}
          >
            {isDE ? "👉 VERFÜGBARKEIT" : "👉 AVAILABILITY"}
          </Typography>

          {/* MAIN QUESTIONS */}
          <Typography
            sx={{
              color: "#ccc",
              whiteSpace: "pre-line",
              lineHeight: 1.7,
            }}
          >
            {isDE
              ? `Wie ist es in deinem Beruf?
                Wirst du da sein?
                Bist du Führungskraft und weißt, ob dein Team vorbereitet ist?

                Bis zu 50% der Mitarbeitenden sind im Krisenfall nicht in der Firma.`
              : `What about your profession?
                Will you be there?
                Are you in a leadership role and do you know if your team is prepared?

                Up to 50% of employees are not present in the company during a crisis.`}
          </Typography>

          {/* EMPHASIS BLOCK */}
          <Box
            sx={{
              p: 3,
              borderRadius: 2,
              border: "1px solid rgba(255,255,255,0.2)",
              background: "rgba(255,255,255,0.03)",
            }}
          >
            <Typography
              sx={{
                color: "#ff8a8a",
                fontWeight: 700,
              }}
            >
              {isDE
                ? `👉 Dein Unternehmen ist ein wichtiger Bestandteil regionaler Resilienz.
                    Die meisten Unternehmen unterstützen ihre Mitarbeitenden dabei.
                    Hilf mit und fülle deinen LAB Score aus.`
                : `👉 Your company is a critical part of regional resilience.
                    Most companies support their employees in being prepared.
                    Contribute and complete your LAB Score.`}
            </Typography>
          </Box>

          <Button
              variant="contained"
              onClick={() => props.handlePageChange?.("AvailabilityCheck")}
              //disabled={selected.length === 0}
              sx={{
                background: "linear-gradient(90deg, #b50d20, #d6293e)",
                fontWeight: 700,
              }}
            >
              {isDE ? "Weiter" : "Continue"}
            </Button>

        </Stack>
      </Paper>
    </Box>
  );
}